import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Logo } from "./Logo";

const NAV = [
  { name: "Services", to: "/#services" },
  { name: "Work", to: "/work" },
  { name: "Pricing", to: "/#pricing" },
  { name: "About", to: "/#about" },
  { name: "Contact", to: "/contact" },
];

const SERVICES = ["Website Design", "Development", "Automation", "Website Care"];

export default function FooterSection() {
  return (
    <footer data-testid="site-footer" className="border-t border-navyline/70 bg-[#05080F]">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
        <div className="flex flex-col gap-12 lg:flex-row lg:justify-between">
          <div className="max-w-sm">
            <Logo />
            <p className="mt-5 font-mono text-[11px] tracking-[0.24em] text-gold/80">
              WEB DESIGN&nbsp;•&nbsp;DEVELOPMENT&nbsp;•&nbsp;AUTOMATION
            </p>
            <p className="mt-4 text-sm leading-relaxed text-slate-500">
              We build websites that tell your story and grow your business — strategy, storytelling, design,
              development, analytics and automation, in one complete digital experience.
            </p>
          </div>
          <nav className="grid grid-cols-2 gap-12 sm:grid-cols-3" aria-label="Footer">
            <div>
              <p className="font-mono text-[11px] font-semibold tracking-[0.24em] text-slate-500">NAVIGATE</p>
              <ul className="mt-5 space-y-3">
                {NAV.map((l) => (
                  <li key={l.name}>
                    <Link
                      to={l.to}
                      data-testid={`footer-${l.name.toLowerCase()}-link`}
                      className="text-sm text-slate-400 transition-colors duration-300 hover:text-gold"
                    >
                      {l.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="font-mono text-[11px] font-semibold tracking-[0.24em] text-slate-500">SERVICES</p>
              <ul className="mt-5 space-y-3">
                {SERVICES.map((s) => (
                  <li key={s} className="text-sm text-slate-400">
                    {s}
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="font-mono text-[11px] font-semibold tracking-[0.24em] text-slate-500">START A PROJECT</p>
              <Link
                to="/contact"
                data-testid="footer-consultation-cta"
                className="group mt-5 inline-flex items-center gap-2 rounded-full border border-gold/50 px-6 py-3 text-sm font-semibold text-gold transition-colors duration-300 hover:bg-gold hover:text-ink"
              >
                Book a Consultation
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </div>
          </nav>
        </div>
        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-navyline/50 pt-8 sm:flex-row sm:items-center">
          <p className="text-xs text-slate-600">© 2026 AT Digital. All rights reserved.</p>
          <p className="font-mono text-[11px] tracking-[0.2em] text-slate-600">
            YOUR BUSINESS DESERVES MORE THAN A TEMPLATE.
          </p>
        </div>
      </div>
    </footer>
  );
}
